import { useId } from "react"
import { recordError } from "src/utilities/errorReporting"

export function useErrorMessageId() {
  const idSuffix = useId().replace(/[^a-z0-9]/gi, "_")

  return `error-${idSuffix}`
}

export function findErrorScrollTarget() {
  const firstErrorElement = document.querySelector("[id^=error-]") as HTMLElement | null
  const id = firstErrorElement?.id

  if (id) {
    try {
      return document.querySelector(`fieldset:has(#${id})`) || document.querySelector(`form:has(#${id})`)
    } catch (error) {
      recordError("Failed to find error scroll target", error)
      try {
        return document.querySelector(`#${id})`)
      } catch (error) {
        recordError("Failed to find error scroll target", error)
        return document.body
      }
    }
  }
}
